import React from "react";
import {Outlet} from "react-router-dom";
import {LoaderOverlay} from "./elements/Loader";

// Redirect domain
import {domain} from "./api/common.js";

// Auth0ProviderWithNavigate
import {Auth0Provider} from "@auth0/auth0-react";
import {useNavigate} from "react-router-dom";

// AuthenticationGuard
import {withAuthenticationRequired} from "@auth0/auth0-react";

const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;
const AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN;
const AUTH_AUDIENCE = process.env.REACT_APP_AUTH_AUDIENCE;

export const Auth0ProviderWithNavigate = ({children}) => {
  const navigate = useNavigate();

  if (!(domain && AUTH_CLIENT_ID)) return console.error("Error: no domain or clientId");

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={AUTH_DOMAIN}
      clientId={AUTH_CLIENT_ID}
      authorizationParams={{
        redirect_uri: `${domain}/user`,
        audience: AUTH_AUDIENCE,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

export const AuthenticationGuard = ({component}) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div>
        <LoaderOverlay />
      </div>
    ),
  });
  return <Component />;
};

function ProtectedOutlet() {
  return <Outlet />;
}

export const ProtectedLayout = withAuthenticationRequired(ProtectedOutlet, {
  onRedirecting: () => (
    <div>
      <LoaderOverlay />
    </div>
  ),
});

export default Auth0ProviderWithNavigate;
